<template>
  <div class="recollect-main-view width-responsiveness">
    <sub-header
      title="Recoletas"
      updated-time
      icon-path="/static/images/icon-recollect.svg"
      back-router-name="Dashboard"
    />

    <recollect-filter />

    <tabs
      class="mb-8 mt-8"
      with-border
      :tabs="tabs"
      :tab-selected="recollectsCurrentTab"
      @tabClicked="changeTab"
    />

    <div class="flex-nowrap">
      <recollect-data-table class="mt-n4" />

      <div
        v-if="recollectListStatusLoading === 'STATUS_END' && recollectList.length === 0"
        class="empty-search flex flex-column align-center justify-center"
      >
        <svg-loader src="/static/images/icon-no-tubes-found.svg" />
        <p>Não encontramos nenhum resultado para sua busca.</p>
      </div>

      <div
        v-if="recollectListStatusLoading === 'STATUS_FAILED' && recollectList.length === 0"
        class="empty-search flex flex-column align-center justify-center"
      >
        <svg-loader src="/static/images/icon-no-tubes-found.svg" />
        <p>Não foi possível buscar recoletas. Tente novamente.</p>
      </div>
    </div>
  </div>
</template>

<script>
import CountIndicator from '@/components/Dashboard/Widgets/CountIndicator'
import CountIcon from '../common/dataTable/CountIcon'
import Card from '@/components/Dashboard/Card'
import SubHeader from '../common/SubHeaderV2'
import comboBox from '../common/ComboBox'
import RecollectDataTable from './RecollectDataTable'
import Spinner from '../common/Spinner'
import { mapActions, mapGetters } from 'vuex'
import SvgLoader from '../common/SvgLoader.vue'
import RecollectFilter from './RecollectFilter.vue'
import Tabs from '../common/Tabs.vue'

export default {
  name: 'RecollectMainView',
  components: {
    'count-indicator': CountIndicator,
    'count-icon': CountIcon,
    card: Card,
    SubHeader,
    'combo-box': comboBox,
    'recollect-data-table': RecollectDataTable,
    spinner: Spinner,
    SvgLoader,
    RecollectFilter,
    Tabs
  },
  data() {
    return {
      filterLabels: [],
      orderBy: null,
      options: [
        { value: 'createdAt', label: 'Data da Recoleta' },
        { value: 'patientName', label: 'Nome do paciente' },
        { value: 'orderId', label: 'OS Alvaro' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'recollectList',
      'recollectListStatusLoading',
      'totalRecollects',
      'totalRealizado',
      'totalDispensadoRecoletar',
      'totalPendente',
      'recollectParans',
      'recollectsCurrentTab',
    ]),
    tabs() {
      return [
        { name: 'Todos', key: 'TODOS', total: this.totalRecollects ?? 0, tooltip: 'Clique aqui para filtrar o Status' },
        { name: 'Pendente', key: 'PENDENTE', total: this.totalPendente ?? 0, tooltip: 'Clique aqui para filtrar o Status' },
        { name: 'Realizado', key: 'REALIZADO', total: this.totalRealizado ?? 0, tooltip: 'Clique aqui para filtrar o Status' },
        { name: 'Dispensado', key: 'DISPENSADO', total: this.totalDispensadoRecoletar ?? 0, tooltip: 'Clique aqui para filtrar o Status' }
      ]
    },
    searchParam: function () {
      return this.$router.history.current.query.typeOfSearch
    },
    searchQuery: function () {
      return this.$router.history.current.query.q
    }
  },
  beforeDestroy() {
    this.clearAllRecollectData();
    this.resetRecollectStore()
  },
  methods: {
    ...mapActions([
      'clearAllRecollectData',
      'selectRecollectParams',
      'setCurrentTabRecollect',
      'resetRecollectStore',
    ]),
    handleClick(route) {
      this.$router.push(route)
    },
    getFilterDefault() {
      this.$router.push({
        path: this.$route.path,
        query: {
          previousDays: 45,
          orderByProperty: 'createdAt',
          orderByDirection: 'desc',
          orderByPatientName: 'patientName'
        }
      })
    },
    redirect(params) {
      const currentUrl = new URL(window.location)

      Object.keys(params).forEach(key => {
        currentUrl.searchParams.set(key, params[key])
      })

      window.history.pushState({}, '', currentUrl)

      this.$router.replace({ path: currentUrl.pathname, query: params }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    async changeTab(index) {
      const statusParsed =
        this.tabs[index].key === 'DISPENSADO' ? 'DISPENSADO_RECOLETAR,DISPENSADO_NOVA_OS' : this.tabs[index].key;

      this.clearAllRecollectData()

      this.setCurrentTabRecollect(index);

      this.selectRecollectParams({ ...this.recollectParans, status: statusParsed, offset: 0 });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylesheets/variables';

.recollect-main-view {
  height: 100vh;
  padding-top: $mainHeaderHeight !important;
  margin-top: 80px;

  .subheader_container {
    height: auto !important;
    position: absolute !important;
    top: 80px !important;

    .header-title {
      line-height: 22px !important;
    }

    .icon-header {
      margin: 0 !important;
      margin-right: 2px;
    }

    .subtitle {
      font-size: 12px;
      height: 14px;
      color: #7a7a7a;
    }
  }

  .text-bold {
    font-weight: bold;
  }
}
</style>
